import React from 'react';
import { 
  Box, 
  Typography, 
  Avatar, 
  IconButton 
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CallIcon from '@mui/icons-material/Call';
import VideocamIcon from '@mui/icons-material/Videocam';

const WhatsAppHeader = ({ contactName, contactAvatar }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        bgcolor: '#075E54', 
        color: 'white',
        p: 1,
        height: 60
      }}
    >
      <IconButton sx={{ color: 'white', mr: 1 }}>
        <ArrowBackIcon />
      </IconButton>
      
      <Avatar 
        src={contactAvatar || 'https://via.placeholder.com/40'} 
        alt={contactName}
        sx={{ mr: 1.5 }}
      />
      
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {contactName}
        </Typography>
        <Typography variant="caption">
          online
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex' }}>
        <IconButton sx={{ color: 'white' }}>
          <VideocamIcon />
        </IconButton>
        <IconButton sx={{ color: 'white' }}>
          <CallIcon />
        </IconButton>
        <IconButton sx={{ color: 'white' }}>
          <MoreVertIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default WhatsAppHeader;
